"use client";
import React, { useState } from "react";
import { BiSolidDollarCircle } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import ModalGetLatestPriceForm from "./ModalGetLatestPriceForm";

const GetLatestPriceModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="">
      <button
        onClick={() => setIsOpen(true)}
        type="button"
        className="group mt-5   bg-orange-500 text-white sm:w-auto transition-all duration-500 py-3 px-6 border font-semibold rounded-full flex items-center justify-center relative overflow-hidden
  before:absolute before:bottom-0 before:left-0 before:w-full before:h-full before:bg-[#071F99] before:translate-y-full hover:before:translate-y-0 before:transition-all before:duration-300 before:rounded-full"
      >
        <p className="relative flex items-center group-hover:text-white text-base text-white">
          <BiSolidDollarCircle className="text-xl mr-2" /> Get Latest Price
        </p>
      </button>

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="relative bg-white rounded-xl shadow-lg w-[90%] max-w-md p-5">
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              <IoClose size={24} />
            </button>

            <h3 className="text-xl mb-5 font-semibold text-secondary-veryDark text-center">
              For more details & information
            </h3>

            <ModalGetLatestPriceForm>
              <></>
            </ModalGetLatestPriceForm>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetLatestPriceModal;
